import { motion } from "framer-motion";
import { MANIFESTO } from "../lib/data";

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-16 md:mb-20"
        >
          <span className="em-tag">04 — Manifesto</span>
          <h2
            className="mt-6 font-display font-extrabold tracking-tighter leading-[0.98]"
            style={{ fontSize: "clamp(2rem, 4.6vw, 4.4rem)" }}
          >
            Four rules we don't break.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-8 md:gap-12">
          <div className="col-span-12 md:col-span-3 hidden md:block">
            <div className="sticky top-32">
              <p className="text-white/40 max-w-xs leading-relaxed text-xs font-mono-em tracking-[0.2em] uppercase">
                Read slowly.<br/>Everything we ship is measured against these four.
              </p>
            </div>
          </div>

          <ol className="col-span-12 md:col-span-9 space-y-10 md:space-y-14">
            {MANIFESTO.map((m, i) => (
              <motion.li
                key={m.n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.9, delay: i * 0.06, ease: [0.16, 1, 0.3, 1] }}
                className="grid grid-cols-12 gap-6 border-t border-white/10 pt-8"
              >
                <div className="col-span-12 md:col-span-2">
                  <span
                    className="font-mono-em block leading-none text-white/70"
                    style={{ fontSize: "clamp(1.4rem, 2vw, 1.8rem)" }}
                  >
                    /{m.n}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-10">
                  <h3
                    className="font-display font-bold tracking-tight leading-[1.08]"
                    style={{ fontSize: "clamp(1.3rem, 2.2vw, 2rem)" }}
                  >
                    {m.title}
                  </h3>
                  <p className="mt-4 text-white/65 leading-relaxed max-w-2xl text-sm md:text-base">
                    {m.body}
                  </p>
                </div>
              </motion.li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
